import { HttpHeaders, HttpParams } from "@angular/common/http";
import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
  TemplateRef,
  AfterViewInit,
  OnDestroy,
} from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { lastValueFrom, Subject } from "rxjs";
import { LoadingService } from "src/app/core/services/loading.service";
import { LoteDetalleUrlService } from "src/app/core/services/lote-detalle-url.service";
import { LoteService } from "src/app/core/services/lote.service";
import { FirmaStateService } from "src/app/core/states/firma/firma-state.service";
import { HelpToursService } from "src/app/core/tours/help-tours.service";
import { Lote } from "src/app/models/Lote.model";
import { LoteDetalleUrl } from "src/app/models/LoteDetalleUrl.model";
import { FileUploadComponent } from "src/app/shared/components/file-upload/file-upload.component";
import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import Swal, { SweetAlertIcon } from "sweetalert2";
import { PdfSanitizerService } from "src/app/core/pdf-sanitizer.service";

interface Item {
  id?: number;
  url: string;
}

@Component({
  selector: "subida-documento-component",
  templateUrl: "./subida-documento.html",
  styleUrls: ["./subida-documento.css"],
})
export class SubidaDocumentoComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  selectedFiles: File | File[] | FileList | null = null;
  private destroy$ = new Subject<void>(); // Usado para desuscribir los Observables al destruir el componente
  private idLote: any = null;
  private lote: Lote;
  public maxFile = 400;
  public maxFileSize = 40;
  public multiple = true;
  public loteDetalleUrls: LoteDetalleUrl[] = [];
  public documentPdfUrl: SafeResourceUrl | null = null;
  public es_grupo: boolean = false;
  @Input() visible: boolean = true;
  @ViewChild(FileUploadComponent) fileUploadComponent!: FileUploadComponent;
  /* TABLE */
  currentItems: Item[] = []; // Los datos para la página actual
  currentPage: number = 1;
  pageSize: number = 5; // Tamaño de página inicial
  totalItems: number = 0;
  spinner: boolean;
  tableHeaders = [{ key: "url_real", label: "Url" }];
  customActions: TableAction[] = [];
  @ViewChild("content") showDocumentReference!: TemplateRef<any>;
  @Output() siguientePaso: EventEmitter<any> = new EventEmitter<any>();
  // Toast
  toast = Swal;

  constructor(
    private loteDetalleUrlService: LoteDetalleUrlService,
    private firmaStateService: FirmaStateService,
    private modalService: NgbModal,
    private loteService: LoteService,
    private sanitizer: DomSanitizer,
    public loading: LoadingService,
    private tours: HelpToursService,
    private pdfSanitizerService: PdfSanitizerService,
  ) {}
  ngOnDestroy(): void {
    this.tours.stop();
  }

  ngAfterViewInit(): void {
    this.onHelp(false);
  }

  onHelp(force = false) {
    this.tours.start("step2_carga_documentos_help", force);
  }

  async ngOnInit() {
    this.toastAlert();
    this.lote = this.firmaStateService.getCurrentState()?.lote;

    this.es_grupo = this.lote != null ? this.lote?.es_grupo : false;
    this.idLote = this.lote?.id;

    this.customActions = [
      {
        label: "Ver Documento",
        handler: (item: Item) =>
          this.verDocumento(this.showDocumentReference, Number(item.id)),
        icon: "fa-solid fa-eye",
        colorClass: "bg-blue",
      },
      {
        label: "Eliminar",
        handler: (item: Item) => this.eliminarLoteDetalleUrl(Number(item.id)),
        icon: "fa-solid fa-trash-can",
        colorClass: "bg-red",
      },
    ];

    if (this.idLote) {
      await this.precargarDataSubidaDocumento();
    }

    if (this.lote?.es_grupo) {
      this.maxFile = 1;
      this.multiple = false;
    } else {
      this.maxFile = 10000;
      this.multiple = true;
    }
  }

  async showLote(id: number) {
    const lote = await lastValueFrom(this.loteService.show(id));
    return lote;
  }

  async precargarDataSubidaDocumento() {
    await this.indexLoteDetalleUrl();
  }

  async indexLoteDetalleUrl() {
    let response = null;
    this.spinner = true;
    let params = new HttpParams();
    params = params
      .set("page", this.currentPage)
      .set("limit", this.pageSize)
      .set("pagination", true);
    let headers = new HttpHeaders();
    if (!this.es_grupo) {
      response = await lastValueFrom(
        this.loteDetalleUrlService.indexDetalleUrl(this.idLote, { params }),
      );
      headers = response.headers;

      this.currentItems = response.body as LoteDetalleUrl[];
      this.spinner = false;
    } else {
      const ids_detalle_url = await this.loteDetalleGrupo();
      if (ids_detalle_url > 0) {
        const response = await lastValueFrom(
          this.loteDetalleUrlService.indexDetalleUrlGrupo(
            this.idLote,
            ids_detalle_url,
            { params },
          ),
        );
        this.currentItems = [response.body] as LoteDetalleUrl[];
        headers = response.headers;
        this.spinner = false;
      } else {
        this.currentItems = [];
      }
    }
    this.totalItems = Number(headers.get("X-Total-Count"));
  }

  /*PARA LISTAR URLS POR RUPOOO*/
  async loteDetalleGrupo() {
    let params = new HttpParams();
    let data = null;
    const result = await lastValueFrom(
      this.loteDetalleUrlService.loteDetalleGrupo(this.idLote, params),
    );
    if (result.body.length > 0) {
      data = result?.body[0].ids_detalle_url;
    } else {
      data = 0;
    }
    return data;
  }

  async eliminarLoteDetalleUrl(idLoteDetalleUrl: number) {
    Swal.fire({
      title: "¡Eliminación de Archivo!",
      text: "¿Deseas eliminar este archivo?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await lastValueFrom(
          this.loteDetalleUrlService.deleteDetalleUrl(
            this.idLote,
            idLoteDetalleUrl,
          ),
        );
        this.alert("success", "Archivo eliminado correctamente");
        await this.indexLoteDetalleUrl();
      }
    });
  }

  handleFiles(files: any) {
    this.selectedFiles = files;
    if (this.validateArchivoGrupo()) {
      this.selectedFiles = [];
      this.fileUploadComponent.clearFiles();
      return;
    } else {
      this.siguientePaso.emit(1);
    }
  }

  async subirDocumentos(): Promise<boolean> {
    let files: File[] =
      this.selectedFiles instanceof File
        ? [this.selectedFiles]
        : Array.isArray(this.selectedFiles)
          ? this.selectedFiles
          : this.selectedFiles
            ? Array.from(this.selectedFiles as FileList)
            : [];

    // 1️⃣ Si hay archivos → SIEMPRE subir
    if (files.length > 0) {
      try {
        const formData = new FormData();
        files.forEach((f) => formData.append("files", f, f.name));

        let es_grupo = this.lote?.es_grupo ?? false;
        formData.append("es_grupo", es_grupo ? "true" : "false");

        await lastValueFrom(
          this.loteDetalleUrlService.addDocumentToLote(this.idLote, formData),
        );

        const loteUpdate = (await this.showLote(this.lote.id)) as Lote;
        this.firmaStateService.updateLote(loteUpdate);

        this.alert("success", "Documentos cargados correctamente");
        this.selectedFiles = [];
        files = [];
        this.fileUploadComponent.clearFiles();
        await this.indexLoteDetalleUrl();

        return true;
      } catch (error) {
        console.error(error);
        this.alert("error", "Error al subir documentos");
        return false;
      }
    }

    let validarDocumentos = await this.validCantidadDocumentos();

    if (!validarDocumentos) {
      this.alert("warning", "Debe seleccionar o arrastrar un documento");
      return false;
    }

    return true;
  }

  public async validCantidadDocumentos(): Promise<boolean> {
    return this.currentItems.length ? true : false;
  }

  async verDocumento(content: any, idDetalleUrl: any) {
    const { body } = await lastValueFrom(
      this.loteDetalleUrlService.showDetalleUrl(this.idLote, idDetalleUrl),
    );

    const safeUrl = this.pdfSanitizerService.getTrustedPdfUrl(
      body?.url_documento,
    );

    if (!safeUrl) {
      this.alert("error", "El documento no es válido");
      return;
    }

    this.documentPdfUrl = safeUrl;

    this.modalService.open(content, {
      centered: true,
      size: "xl",
    });
  }

  validateArchivoGrupo(): boolean {
    if (this.es_grupo && this.currentItems.length > 0) {
      this.alert(
        "warning",
        "Solo puede subir un archivo",
        "Si el sobre es por grupo solo puede existir un archivo.",
      );

      return true;
    }

    return false;
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage;
    this.indexLoteDetalleUrl();
  }

  onPageSizeChange(newSize: number): void {
    this.pageSize = newSize;
    this.currentPage = 1; // Siempre vuelve a la primera página al cambiar el tamaño
    this.indexLoteDetalleUrl();
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }
}
